import ContainerLookup from './views/ContainerLookup/ContainerLookup';
import CertifyGuarantee from './views/CertifyGuarantee/CertifyGuarantee';
import FreightRelease from './views/FreightRelease/FreightRelease';
import RailRequest from './views/RailRequest/RailRequest';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { PayCargo } from './views/PayCargo/PayCargo';

export type routeDefinition = {
  title: string;
  path: string;
  component: JSX.Element;
  icon: IconDefinition;
  disabled?: boolean;
  index?: boolean;
};

export const defaultRoute: routeDefinition = {
  title: 'CES Container Lookup',
  path: '/containerLookup',
  icon: solid('truck-moving'),
  component: <ContainerLookup />,
  index: true,
};

export const routes: routeDefinition[] = [
  defaultRoute,
  {
    title: 'Certify Guarantee',
    path: '/certifyGuaranteedPayment',
    icon: solid('file-invoice-dollar'),
    component: <CertifyGuarantee />,
  },
  {
    title: 'Freight Release',
    path: '/freightRelease',
    icon: solid('dolly'),
    component: <FreightRelease />,
  },
  {
    title: 'Rail Request',
    path: '/railRequest',
    icon: solid('train'),
    component: <RailRequest />,
  },
  {
    title: 'Pay Cargo',
    path: '/payCargo',
    icon: solid('money-check-dollar'),
    component: <PayCargo />,
  },
];
